export default (theme) => ({
  margin: {
    margin: theme.spacing.unit,
  },
});
